import { fetcher } from '../utils'
import { FlowArgsVO } from '@repo/types'

export default async (connectionKey: string, flowId: string): Promise<FlowArgsVO> =>
  fetcher(`/api/chats/${connectionKey}/flows/args/${flowId}`, 'GET', undefined)
